
export default {

    stats: function(params = {}){
        return window.axios.get('/api/stats', {
            params: params,
        });
    },

}


// WEBPACK FOOTER //
// ./resources/assets/js/services/StatsService.js